module.exports = __webpack_public_path__ + "assets/vertex.8a65ee6d.svg";